import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@psei/ng/button';
import { IconModule } from '@psei/ng/icon';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { PseicFormFieldModule } from '../pseic-form-field/pseic-form-field.module';
import { PseicAttachmentsComponent } from './pseic-attachments.component';

@NgModule({
    declarations: [PseicAttachmentsComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        PseicFormFieldModule,
        IconModule,
        FormsModule,
        ButtonModule,
        PseiNgCustomModule,
    ],
    exports: [
        PseicAttachmentsComponent
    ]
})
export class PseicAttachmentsModule {
}
